import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { httpRequest } from '~/adapters/httpRequest';
import { host } from '~/config/settings/worktango.settings';
import * as transformers from '../transformers';
import * as schemas from '../schemas';

const fetchAllIcons = createAsyncThunk('language/fetchAllIcons', async () => {
  const url = `${host}/icons`;
  const res = await httpRequest(url);

  const icons = transformers.iconsFrom(res?.payload?.icons);
  const normalizedData = normalize(icons, [schemas.icon]);
  return normalizedData;
});

export const iconActions = {
  fetchAllIcons,
};
